import type { RouteRecordRaw } from 'vue-router';
import { SETUP_ROUTE_NAME } from '@/consts';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const setupCheckoutRoutes: RouteRecordRaw = {
  path: '/setup/checkout',
  component: () => import('@/layouts/main.vue'),
  meta: { requireAuth: true, requireStoreId: true, i18n },
  children: [
    { name: SETUP_ROUTE_NAME.CHECKOUT_SETUP, path: '', component: () => import('./SetupCheckout.vue') },
  ],
};
